import Immutable from 'immutable';
import {
  FLAG_GETTING_ROUTES,
  GET_ROUTE,
  GET_ROUTES,
  CLEAR_ROUTES,
  CLEAR_ROUTE,
  FLAG_ROUTE_ACTIVITY,
} from '../../../actions/types';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_GETTING_ROUTES:
      return state.setIn(['all', 'loading'], action.payload);
    case GET_ROUTES:
      return state.setIn(['all', 'content'], Immutable.Map(action.payload));
    case CLEAR_ROUTES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_ROUTE_ACTIVITY:
      if (action.payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(action.payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_ROUTE:
      return state.setIn(['current', 'content'], Immutable.Map(action.payload));
    case CLEAR_ROUTE:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
